module.exports = __webpack_public_path__ + "static/media/LeftoverSalmonreuniontourBirchmereTheater9-21-2011Handdrawn4colorscreenprint.95581fc7.webp";